import {HttpContextToken, HttpEvent, HttpHandlerFn, HttpRequest} from '@angular/common/http'
import {inject} from '@angular/core'
import {ConfigService} from '@sparbanken-syd/sparbanken-syd-bankid'
import {Observable} from 'rxjs'

export const GITLAB_ACCESS_TOKEN = new HttpContextToken<string | null>(() => null)
export const GITLAB_API_TOKEN = new HttpContextToken<string | null>(() => null)


export const authInterceptor = (
  req: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const configService = inject(ConfigService)

  let headers = req.headers

  const gitLabAccessToken = req.context.get(GITLAB_ACCESS_TOKEN)

  if (gitLabAccessToken) {
    headers = headers.set('Authorization', `Bearer ${gitLabAccessToken}`)
    // No more after this.
    return next(req.clone({headers}))
  }

  const token = configService.accessToken()

  if (token) {
    headers = headers.set('Authorization', `Bearer ${token}`)
  }

  const gitLabApiToken = req.context.get(GITLAB_API_TOKEN)
  if (gitLabApiToken) {
    headers = headers.set('X-GitLabApi-Token', gitLabApiToken)
    return next(req.clone({headers}))
  }

  const authReq = req.clone({headers})
  return next(authReq)
}
